<template>
        <div class="overf-steps">
            <div class="step-container">
                <div :class="'step '+(step == 1 ? 'active':'')" data-step="1" :data-test="step">
                    <div class="step-number">01</div>
                    <div class="head-title">
                        <h6>{{title1}}</h6>
                        <small>{{desc1}}</small>
                    </div>
                </div>
                <div :class="'step '+(step == 2 ? 'active':'')" data-step="2">
                    <div class="step-number">02</div>
                    <div class="head-title">
                        <h6>{{title2}}</h6>
                        <small>{{desc2}}</small>
                    </div>
                </div>  
                <div :class="'step '+(step == 3 ? 'active':'')" data-step="3">
                    <div class="step-number">03</div>
                    <div class="head-title">
                        <h6>{{title3}}</h6>
                        <small>{{desc3}}</small>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    name: 'Breadcrumbs',
    props: ['title1','desc1','title2','desc2','title3','desc3','step'],
    data () {
        return {
            // currentStep: 1,
            totalSteps: 3,
            //step: 2
        }
    },
    computed: {
        currentStep(){
            return this.step;
        }
    },
    methods: {

    },
    mounted() {
        console.log('step', this.step);
        
    }
}

</script>

<style>
.activeX{
    font-display: inherit;
}
</style>